import styled, { css } from "styled-components";
import { breakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.div<{ isSmall?: boolean; variantOutline?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0 auto var(--spacing-3);

    @media screen and (min-width: ${breakpoints.xl}) {
        margin: 0 auto;
    }

    ${({ variantOutline }) =>
        variantOutline &&
        css`
            padding-block: calc(var(--spacing-3) / 2);
            padding-inline: var(--spacing-3);
            border: 1px solid var(--color-grey-2);
        `};
`;
